(() => {
  const moveTrack = (button) => {
    const selector = button.dataset.carouselTarget;
    const track = selector ? document.querySelector(selector) : button.closest('[data-carousel]')?.querySelector('[data-carousel-track]');
    if (!track) return;

    const direction = button.dataset.carouselDirection === 'previous' ? -1 : 1;
    const item = track.querySelector('[data-carousel-item]') || track.firstElementChild;
    const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    const distance = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-carousel-direction]');
    if (button) moveTrack(button);
  });
})();
